import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';
import { Icons } from '../../types/Icons';
import { BaseCategory } from '@usercentrics/cmp-browser-sdk';
import ConsentHelper from '../../ConsentHelper/ConsentHelper';

@Component({
  tag: 'cmm-category-overview',
  shadow: false,
})
export class CategoryOverview implements ComponentInterface {
  @Prop() handleCategoryChange: (event: MouseEvent) => void;
  @Prop() scrollToDetails: (categoryLabel: string) => void;
  @Prop() categories: BaseCategory[] = null;

  public render(): JSX.Element {
    if (!this.categories) {
      return false;
    }

    return (
      <Host>
        <ul class="category-overview">
          {this.categories.map((category: BaseCategory) => (
            <li class="category-overview-item" data-category-wrapper={category.label}>
              <label class="category-label cmm-checkbox">
                <input
                  type="checkbox"
                  checked={ConsentHelper.getCategoryChecked(category) || category.isEssential}
                  class={`cmm-checkbox-input cmm-checkbox-input--category ${ConsentHelper.getCheckboxClass(category)}`}
                  disabled={category.isEssential}
                  data-category={category.label}
                  data-test="handle-category-change"
                  onClick={(event: MouseEvent): void => this.handleCategoryChange(event)}
                />
                <div class="cmm-checkbox-fake" />
                <div class="consent-item__information">
                  <span class="consent-item__name">{category.label}</span>
                  <button
                    type="button"
                    class="consent-item__icon"
                    data-test="scroll-to-details"
                    aria-label={category.label}
                    onClick={(): void => this.scrollToDetails(category.label)}
                  >
                    <cmm-icon name={Icons.INFO}></cmm-icon>
                  </button>
                </div>
              </label>
            </li>
          ))}
        </ul>
      </Host>
    );
  }
}
